module.exports = __webpack_public_path__ + "img/target.c33ee511.png";